import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmationSettings {
    title: string;
    message: string;
}

@Component({
    selector: 'nova-job-fulfillment-type-selector-confirmation',
    template: `
        <div class="nova__dialog__toolbar">
            <div class="nova__dialog__toolbar__title">
                {{ model.title }}
            </div>
        </div>
        <div
            mat-dialog-content
            class="nova__dialog__content">
            <div [innerHTML]="model.message"></div>
            <mat-dialog-actions class="nova__dialog__content__actions">
                <button
                    mat-raised-button
                    color="primary"
                    [mat-dialog-close]="true"
                    >Yes</button
                >
                <button
                    mat-raised-button
                    color="default"
                    [mat-dialog-close]="false"
                    cdkFocusInitial
                    >No, Cancel</button
                >
            </mat-dialog-actions>
        </div>
    `
})
export class JobFulfillmentTypeSelectorConfirmationComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public model: ConfirmationSettings) {}
}
